// Vertaalt het doelgroep-veld (target_audience) naar de UI-taal.
// Ondersteunt komma-gescheiden waarden (bijv. "Jongeren,Volwassenen").
const AUD_KEY = {
  kinderen: 'age.children',
  jongeren: 'age.youth',
  volwassenen: 'age.adults',
  senioren: 'age.seniors',
  iedereen: 'age.everyone',
  'kinderen en gezinnen': 'age.children_families',
  'vrouwen 18+': 'age.women_18plus',
};

export const translateAudience = (audience, t) => {
  if (!audience) return '';
  return audience
    .split(',')
    .map((a) => {
      const key = AUD_KEY[a.trim().toLowerCase()];
      return key ? t(key) : a.trim();
    })
    .filter(Boolean)
    .join(', ');
};
